import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/finished-goods`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      status: params.status || undefined,
      is_orderable: params.is_orderable !== undefined && params.is_orderable !== '' ? params.is_orderable : undefined,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/finished-goods`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/finished-goods/${id}`, { ...payload }, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/finished-goods/${id}`, config);
};

export const All = (payload) => {
  return APIService.get(`v01/active-finished-goods`, {
    params: {
      needs_production: payload?.needs_production || false,
    }
  });
}

export const Show = (id, config = {}) => {
  return APIService.get(`/v01/finished-goods/${id}`, config);
};

export const ChangePrice = (payload, config = {}) => {
  return APIService.post(`/v01/change-price`, { ...payload }, config);
};

export const PriceHistories = (params = {}, config = {}) => {
  return APIService.get(`/v01/price-histories`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      sku: params.sku,
      type: params.type,
      price_type: params.price_type || undefined,
    },
  })
};

export const Activate = (payload, config = {}) => {
  const { id } = payload;
  return APIService.post(`/v01/finished-good-activate/${id}`, { ...payload }, config);
};

export const ToggleOrderable = (payload, config = {}) => {
  const { id } = payload;
  return APIService.patch(`/v01/finished-goods/${id}/toggle-orderable`, { ...payload }, config);
};

export const WarehouseAvailability = (id, config = {}) => {
  return APIService.get(`/v01/finished-goods/${id}/warehouse-availability`, config);
};

export const SyncWarehouseAvailability = (id, body, config = {}) => {
  return APIService.put(`/v01/finished-goods/${id}/warehouse-availability`, body, config);
};

export const SetWarehouseAvailability = (id, body, config = {}) => {
  return APIService.patch(`/v01/finished-goods/${id}/warehouse-availability`, body, config);
};

export const Export = (params) => {
  return APIService.get('/v01/finished-goods/export', {
    params: {
      keyword: params.keyword || undefined,
      status: params.status || undefined,
      is_orderable:
        params.is_orderable !== undefined && params.is_orderable !== ''
          ? params.is_orderable
          : undefined,
    },
  });
};

const FinishedGoodService = {
  List,
  Create,
  Put,
  Delt,
  All,
  Show,
  ChangePrice,
  PriceHistories,
  Activate,
  ToggleOrderable,
  WarehouseAvailability,
  SyncWarehouseAvailability,
  SetWarehouseAvailability,
  Export,
};
export default FinishedGoodService;
